var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn",
    {
      staticClass: "ma-0 mr-3",
      attrs: { disabled: _vm.disabled, small: "", color: "white" },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _c("v-icon", { attrs: { size: "14", left: "" } }, [
        _vm._v(_vm._s(_vm.icon))
      ]),
      _vm._v(" "),
      _c(
        "span",
        { staticStyle: { "text-transform": "none", "font-size": "12px" } },
        [_vm._v(_vm._s(_vm.label))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-160071a5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-160071a5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Management/ViewPage/ViewPageButton.vue
// module id = null
// module chunks = 